import { render, staticRenderFns } from "./DouYinProduct.vue?vue&type=template&id=a09bfeec&scoped=true"
import script from "./DouYinProduct.vue?vue&type=script&lang=js"
export * from "./DouYinProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09bfeec",
  null
  
)

export default component.exports